import axios from 'axios';
import { FormResponseType } from './types/FormResponseType';

const { locale } = document.documentElement.dataset;

export default class ConnectionService {
  private abortController: AbortController;

  public async checkEmailExist(email: string) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const url = new URL(
      `${window.location.origin}/s/${locale}/checkout/registration/check-email`
    );
    url.searchParams.append('email', email);
    const data = {};

    try {
      const response = await axios({
        method: 'POST',
        url: url.toString(),
        data,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        signal: this.abortController.signal,
      });

      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError') return;

      return error.response.data;
    }
  }

  public async getFormConnection(): Promise<FormResponseType> {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const url = new URL(
      `${window.location.origin}/s/${locale}/checkout/authentication/get-form`
    );

    try {
      const response = await axios({
        method: 'GET',
        url: url.toString(),
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        signal: this.abortController.signal,
      });

      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError') return;

      return error.response.data;
    }
  }

  public async getFormRegistration(email: string): Promise<FormResponseType> {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const url = new URL(
      `${window.location.origin}/s/${locale}/checkout/registration/get-form`
    );

    const orderIdElement = document.querySelector('[data-order-id]');
    const orderId =
      orderIdElement instanceof HTMLElement
        ? orderIdElement.dataset.orderId ?? null
        : null;

    try {
      const response = await axios({
        method: 'GET',
        url: url.toString(),
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        params: {
          orderId,
          email,
        },
        signal: this.abortController.signal,
      });

      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError') return;

      return error.response.data;
    }
  }

  public async sendForm(data: FormData, url: string) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    try {
      const response = await axios({
        method: 'POST',
        url,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        signal: this.abortController.signal,
        data,
      });

      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError') return {};

      return error.response.data;
    }
  }

  static async getFormPasswordReset(): Promise<FormResponseType> {
    const url = new URL(
      `${window.location.origin}/s/${locale}/checkout/authentication/get-password-reset-request-form`
    );

    try {
      const response = await axios({
        method: 'GET',
        url: url.toString(),
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  static async submitFormPasswordReset(
    formData: FormData,
    url: string,
    method: string
  ) {
    try {
      const response = await axios({
        method,
        url,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        data: formData,
      });

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
}
